import React, { useEffect, useState } from 'react'
import { Route, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { routes } from '@store/routes/index'
import { useHasPermission } from '@helpers/hooks'
import { authService } from '@store/services/ServiceAuth'
import { ensureSemanticUiStyles } from '@styles/ensureSemanticUiStyles'
import SpinnerSegment from '@components/SpinnerSegment'

const PublicRoute = ({ component: Component, restricted, isFullPage, ...rest }) => {
    const { t } = useTranslation()
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(true)
    const [currentPath] = useState(window.location.pathname)
    const user = useSelector((state) => state?.user)

    const canAccessWarehousing = useHasPermission('users.c_terminal_warehouse')

    useEffect(() => {
        async function checkUser() {
            ensureSemanticUiStyles().catch(() => {})

            if (restricted) {
                const result = await authService.validateToken()
                setIsLoading(false)

                if (result !== false && restricted && user?.role !== undefined && user?.role !== null) {
                    if (user.role !== 5) {
                        history.push(routes.DASHBOARD)
                    } else if (canAccessWarehousing) {
                        history.push(routes.WAREHOUSE_TRACKER)
                    } else {
                        history.push(routes.ATTENDANCE_TRACKER)
                    }
                }
            } else {
                setIsLoading(false)
            }
        }

        checkUser()
        // eslint-disable-next-line
    }, [history, currentPath, restricted])

    if (isLoading) {
        return <SpinnerSegment loading={true} loadingMessage={t('loading')} fullHeight />
    }

    return <Route {...rest} render={(props) => <Component {...props} />} />
}

export default PublicRoute
